export default __webpack_public_path__ + "static/img41h-676f87751ba5c815967b5e65ded6166b.jpg";